export default () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect
            x="1.5"
            y="5.5"
            width="21"
            height="15"
            rx="3.5"
            stroke="#1F1F1F"
        />
        <path
            d="M13.5 5.5V20.5"
            stroke="#1F1F1F"
            strokeLinecap="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 9.5C16 9.22386 16.2239 9 16.5 9H19.5C19.7761 9 20 9.22386 20 9.5C20 9.77614 19.7761 10 19.5 10H16.5C16.2239 10 16 9.77614 16 9.5ZM16 11.5C16 11.2239 16.2239 11 16.5 11H19.5C19.7761 11 20 11.2239 20 11.5C20 11.7761 19.7761 12 19.5 12H16.5C16.2239 12 16 11.7761 16 11.5ZM16.5 13C16.2239 13 16 13.2239 16 13.5C16 13.7761 16.2239 14 16.5 14H19.5C19.7761 14 20 13.7761 20 13.5C20 13.2239 19.7761 13 19.5 13H16.5Z"
            fill="#1F1F1F"
        />
    </svg>
);
